import { PageTemplate } from "features/users/templates";
import { clientsTemplateConfig } from "../config";

export const Clients = () => {
  return <PageTemplate template={clientsTemplateConfig} />;
};
